/**
 * DocsLanding — /docs index.
 * Renders the landing markdown alongside the rail.
 */

import type { ReactElement } from 'react';

import { DocsMarkdown } from '@/pages/docs/DocsMarkdown';

import indexMd from '@/pages/docs/content/index.md?raw';

export function DocsLanding(): ReactElement {
  return <DocsMarkdown text={indexMd} />;
}
